<template>
  <ThemeECommerceLayoutPage
    :title="asyncCategory?.section.title"
    :description="asyncCategory?.section.description"
    :breadcrumbs="breadcrumbs"
    :categories="asyncCategory?.categoryButtonItems"
    :event-name="eventName"
    :category-event-name="categoryEventName"
  >
    <div v-if="galleries.length > 0">
      <ThemeECommerceDisplayGallery
        :items="galleries"
        :action-event-name="eventName"
        fb-event-name="Gallery"
        event-name="preview"
      />
      <Pagination v-model="page" :total="total" :per-page="perPage" />
    </div>
    <LandingNoData v-else />
  </ThemeECommerceLayoutPage>
</template>

<script setup lang="ts">
const {
  categoryEventName,
  eventName,
  breadcrumbs,
  asyncCategory,
  page,
  perPage,
  total,
  galleries,
} = await useGalleryPage();
</script>
